var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage steps-container venn-diagram-container",
    class: {
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "scaled"
  }, [_c('div', {
    staticClass: "venn-diagram-circles"
  }, [_c('svg', {
    attrs: {
      "width": "980px",
      "height": "460px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.vennDiagramSVG)
    }
  })]), _c('div', {
    staticClass: "left-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-left"
  }, [_vm.currentRound.imageLeft ? _c('img', {
    attrs: {
      "src": _vm.currentRound.imageLeft
    }
  }) : _vm._e()]), _vm._l(_vm.stepsLeft, function (step) {
    return _c('div', {
      key: step.stepIndex,
      staticClass: "left-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": step.stepIndex,
        "text": step.answer
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "center-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-center"
  }, [_vm.currentRound.imageCenter ? _c('img', {
    attrs: {
      "src": _vm.currentRound.imageCenter
    }
  }) : _vm._e()]), _vm._l(_vm.stepsCenter, function (step) {
    return _c('div', {
      key: step.stepIndex,
      staticClass: "center-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": step.stepIndex,
        "text": step.answer
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "right-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-right"
  }, [_vm.currentRound.imageRight ? _c('img', {
    attrs: {
      "src": _vm.currentRound.imageRight
    }
  }) : _vm._e()]), _vm._l(_vm.stepsRight, function (step) {
    return _c('div', {
      key: step.stepIndex,
      staticClass: "right-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": step.stepIndex,
        "text": step.answer
      }
    })], 1);
  })], 2)]), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }